module.exports = __webpack_public_path__ + "static/img/img_tjjd.4466a986.png";